<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <el-form :model="detailInfo" ref="detailInfo" label-width="0px" class="demo-dynamic form-horizontal detailPage">
      <el-tabs type="border-card" v-model="pageLangCode">
        <el-tab-pane :name="langItem.langCode" :label="$t('message.' + langItem.langCode)"
          v-for="(langItem, index) in detailInfo.langMaps" :key="index">
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Rewards Title
                </label>
                <div class="col-sm-10">
                  <el-form-item :prop="'langMaps.' + index + '.name'" :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur'
                  }">
                    <el-input v-model="langItem.name" show-word-limit></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Category
                </label>
                <div class="col-sm-10">
                  <el-form-item prop="giftCategoryId" :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur'
                  }">
                    <el-select class="select-body" v-model="detailInfo.giftCategoryId" placeholder="Pleace select">
                      <el-option v-for="item in categoryList" :key="item.id" :label="item.categoryNameEn"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Rewards Image
                </label>

                <div class="col-sm-10" style="display: flex">
                  <vuedraggable v-model="langItem.images" class="drag">
                    <transition-group>
                      <div class="dragInfo" v-for="item in langItem.images" :key="item.imageUrl">
                        <el-image :src="item.showImageUrl"></el-image>
                        <i class="el-icon-delete dragDelete" @click="handleRemove(item, index)"></i>
                      </div>
                    </transition-group>
                  </vuedraggable>

                  <el-upload action="#" :http-request="(params) => { uploadFile(params, index) }"
                    :file-list="langItem.images" v-if="langItem.images.length < 5" list-type="picture-card"
                    accept=".png, .jpg , .jpeg" :auto-upload="true" :show-file-list="false">
                    <div slot="tip" v-if="uploadErr" style="color: red; font-size: 10px" class="el-upload__tip">
                      The uploaded file should not exceed 5MB
                    </div>
                    <i slot="default" class="el-icon-plus"></i>
                    <div slot="file" slot-scope="{ file }">
                      <img class="el-upload-list__item-thumbnail" :src="file.showImageUrl" alt="" />
                      <span class="el-upload-list__item-actions">
                        <span class="el-upload-list__item-delete" @click="handleRemove(file, index)">
                          <i class="el-icon-delete"></i>
                        </span>
                      </span>
                    </div>
                  </el-upload>
                </div>
                <label class="col-sm-2 control-label"></label>
                <el-form-item class="col-sm-10" :prop="'langMaps.' + index + '.imageListIsNull'" :rules="{
                  required: true,
                  message: $t('message.required'),
                  trigger: 'change',
                }">
                  <el-input style="display: none;" v-model="langItem.imageListIsNull" show-word-limit></el-input>
                </el-form-item>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> Conversion time for the rewards </label>
                <div class="col-sm-10">
                  <el-date-picker v-model="detailInfo.conversionTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">J Coins</label>
                <div class="col-sm-10">
                  <el-form-item prop="stampQty" :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }">
                    <el-input-number v-model="detailInfo.stampQty" :min="0"></el-input-number>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">Qty in Public WH</label>
                <div class="col-sm-10">
                  <el-form-item prop="inventory" :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }">
                  <!-- :disabled="!!$route.query.id" -->
                    <el-input-number disabled v-model="detailInfo.inventory"
                      :min="0"></el-input-number>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">Limited Item</label>
                <div class="col-sm-10">
                  <el-form-item prop="isRedemptionLimit" :rules="{
                    required: false,
                    message: $t('message.required'),
                    trigger: 'blur'
                  }">
                    <el-checkbox v-model="detailInfo.isRedemptionLimit"></el-checkbox>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">Redemption Limit</label>
                <div class="col-sm-10">
                  <el-form-item prop="redemptionLimit">
                    <el-input-number :disabled="!!!detailInfo.isRedemptionLimit" :max="9999"
                      v-model="detailInfo.redemptionLimit" :min="0"></el-input-number>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Description
                </label>
                <div class="col-sm-10">
                  <el-form-item :prop="'langMaps.' + index + '.descr'" :rules="{
                    required: false,
                    message: $t('message.required'),
                    trigger: 'blur'
                  }">
                    <el-input v-model="langItem.descr" show-word-limit></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Reward Status
                </label>
                <div class="col-sm-4">
                  <el-form-item prop="giftStatus" :rules="{
                    required: false, message: $t('message.required'), trigger: 'change'
                  }">
                    <el-select v-model="detailInfo.giftStatus" v-bind:placeholder='$t("message.PleaseSelect")'>
                      <el-option v-for="item in giftStatusObj" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Status
                </label>
                <div class="col-sm-4">
                  <el-form-item prop="status" :rules="{
                    required: false, message: $t('message.required'), trigger: 'change'
                  }">
                    <el-select v-model="detailInfo.status" v-bind:placeholder='$t("message.PleaseSelect")'>
                      <el-option v-for="item in statusObj" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="hr-line-dashed"></div>
              <div class="form-group">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <el-button type="primary" @click="checkEvent()" v-if="(checkPermission('REWARDS_LIST_EDIT') &&
                      $route.query.id) ||
                      (checkPermission('REWARDS_LIST_ADD') &&
                        !$route.query.id)
                      ">Save</el-button>
                    <el-button @click="showWarning()">{{
                      $t("message.Cancel")
                    }}</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </div>
</template>
<script>
import config from "../config";
import vuedraggable from "vuedraggable";
export default {
  mixins: [config.globalMixin],
  data() {
    return {
      categoryList: [],
      detailInfo: {
        langMaps: [],
        status: "",
        type: "",
        newsDate: "",
        applyUserGroup: 0,
        inventory: 0,
        redemptionLimit: 0,
        isRedemptionLimit: 0,
        giftCategoryId: ''
      },
      statusObj: [],
      giftStatusObj: [],
      period: [],
      applyObj: [],
      pageLangCode: 'en_US',
      uploadErr: false
    };
  },
  components: { vuedraggable },
  computed: {
    _language() {
      return this.$store.state.userInfo.langCode;
    },
    categoryNameMap(){
      return {
        0:'name',
        1:'nameCn',
        2:'nameHk'
      }
    }
  },
  watch: {
    _language: function () {
      this.setObj();
    },
    detailInfo: {
      handler: function () {
        this.$store.state.edit = true;
      },
      deep: true
    },
     'detailInfo.isRedemptionLimit': {
      // 立即执行一次（页面初始化就触发，保证初始状态正确）
      immediate: true,
      // 深度监听（对象属性变化必加）
      deep: true,
      // 监听回调
      handler(newVal) {
        // 当 isRedemptionLimit 变为 false 时，将 redemptionLimit 设为 0
        if (newVal === false) {
          this.detailInfo.redemptionLimit = 0;
        }
      }
    }
  },



  created() {
    var obj = [];
    this.pageLangCode = this.$store.state.userInfo.language[0].langCode;
    for (var i = 0; i < this.$store.state.userInfo.language.length; i++) {
      obj.push({
        langCode: this.$store.state.userInfo.language[i].langCode,
        title: "",
        image: "",
        image2: "",
        image3: "",
        image4: "",
        image5: "",
        showImage: "",
        descr: "",
        images: [],
        imageListIsNull: ""
      });
    }
    this.$set(this.detailInfo, "langMaps", obj);
    this.getCategoryList()
    this.init();
  },
  mounted() { },
  methods: {
    async getCategoryList() {
      var objdata = this.getAuthObj();

      objdata.pageIndex = 1;
      objdata.pageSize = 99999;
      objdata.name = "";
      objdata.type = "publicity_category"

      objdata.apiUrl = this.apiConfig.giftCategoryList;
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.categoryList = data.data.result.giftCategoryList;
    },
    setObj: function () {
      this.statusObj = [
        {
          value: 1,
          label: this.$i18n.t("message.Active")
        },
        {
          value: 0,
          label: this.$i18n.t("message.Inactive")
        }
      ];
      this.giftStatusObj = [
        {
          value: 0,
          label: "Not in stock"
        },
        {
          value: 1,
          label: "In stock"
        },
        {
          value: 2,
          label: "Coming soon"
        },
        {
          value: 3,
          label: "Limited items "
        }
      ];
      this.applyObj = [
        {
          value: 0,
          label: "All User"
        },
        {
          value: 1,
          label: "Active User"
        }
      ];
    },
    async init() {
      let id = this.$route.query.id;
      var that = this;
      if (id) {
        let obj = this.getAuthObj();
        obj.id = id;
        obj.apiUrl = this.apiConfig.giftDetail;
        let data = await this.$store.dispatch("apiEvent", obj);
        if (data == "000104") {
          this.timeoutEvent();
          return;
        }
        if (data.data.result.startTime) {
          this.period = [data.data.result.startTime, data.data.result.endTime]
        }
        if (!data) return;
        delete data.data.result['userId']
        data.data.result.isRedemptionLimit = data.data.result.isRedemptionLimit ? true : false
        this.$set(this, "detailInfo", data.data.result);
        if(!this.detailInfo.giftCategoryId && this.categoryList && this.categoryList.length) this.detailInfo.giftCategoryId = this.categoryList[0].id
        this.detailInfo.langMaps.forEach(item => {
          if (!item.images) item.images = [];
          if (!item.imageListIsNull) item.imageListIsNull = 'no';
          const numList = ["", "2", "3", "4", "5"]
          numList.forEach(num => {
            if (item[`image${num}`]) {
              item.images.push({
                imageUrl: item[`image${num}`],
                showImageUrl: item[`showImage${num}`]
              })
            }
          })
          if (!item.images.length) item.imageListIsNull = ''
          else item.imageListIsNull = 'no'
        })
        setTimeout(function () {
          that.$store.state.edit = false;
        }, 500);
      } else {
        setTimeout(function () {
          that.$store.state.edit = false;
        }, 500);
      }
      this.setObj();
    },
    checkEvent: function () {
      this.$refs["detailInfo"].validate(valid => {
        if (valid) {
          this.submit();
        } else {
          this.$toastr.w(this.$i18n.t("message.fillRequired"));
          return false;
        }
      });
    },
    hadnleChangeImages(resList, index) {
      this.detailInfo.langMaps[index].images = resList
    },
    showWarning(type) {
      var that = this;
      if (!type) {
        that.$router.go(-1);
      } else if (type == 1) {
        this.$store.commit("setwarning", {
          string: this.$i18n.t("message.deleteContent"),
          boolean: true,
          button: [
            {
              name: this.$i18n.t("message.Confirm"),
              callBack: function () {
                that.$store.commit("setwarning", {
                  string: "",
                  boolean: false
                });
                that.callDelete();
              }
            },
            {
              name: this.$i18n.t("message.Cancel"),
              callBack: function () {
                that.$store.commit("setwarning", {
                  string: "",
                  boolean: false
                });
              }
            }
          ]
        });
      }
    },
    async uploadFile(params, index) {
      if (!this.handleCheckUploadFileSize(params.file)) return false
      let obj = this.getAuthObj();
      obj.file = params.file;
      obj.apiUrl = this.apiConfig.upload;
      var data = await this.$store.dispatch("apiEventFromData", obj);
      if (data == this.TOKEN_EXPIRED) {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.getObject(
        this.detailInfo.langMaps,
        this.pageLangCode
      ).images.push({
        imageUrl: data.data.result.url,
        showImageUrl: data.data.result.showUrl
      });
      this.getObject(
        this.detailInfo.langMaps,
        this.pageLangCode
      ).imageListIsNull = 'no'
      const refForm = this.$refs["detailInfo"]
      this.$nextTick(() => {
        setTimeout(function () {
          refForm.clearValidate('langMaps.' + index + '.imageListIsNull')
        }, 100);
      })

      this.$forceUpdate()
    },
    handleRemove(file, langIndex) {
      var index = "";
      this.detailInfo.langMaps[langIndex].images.forEach((item, i) => {
        if (item.imageUrl == file.imageUrl) {
          index = i;
        }
      });
      this.detailInfo.langMaps[langIndex].images.splice(index, 1);
      if (!this.detailInfo.langMaps[langIndex].images.length) this.detailInfo.langMaps[langIndex].imageListIsNull = ''
      this.$forceUpdate()
    },
    async submit() {
      try {
        let obj = this.getAuthObj();
        for (var key in this.detailInfo) {
          obj[key] = this.$lodash.cloneDeep(this.detailInfo[key])
        }
        obj.langMaps.forEach(lang => {
          const numList = ["", "2", "3", "4", "5"]
          numList.forEach(num => {
            if (lang.images[num ? Number(num) - 1 : 0]) {
              lang[`image${num}`] = lang.images[num ? Number(num) - 1 : 0].imageUrl
              lang[`showImage${num}`] = lang.images[num ? Number(num) - 1 : 0].showImageUrl
            } else {
              lang[`image${num}`] = null
              lang[`showImage${num}`] = null
            }
          })
          delete lang.images
          delete lang.imageListIsNull
        })
        obj.isRedemptionLimit = obj.isRedemptionLimit ? 1 : 0
        if (this.period.length) {
          obj.startTime = this.period[0];
          obj.endTime = this.period[1];
        } else {
          obj.startTime = "";
          obj.endTime = "";
        }
        var data;
        if (this.$route.query.id) {
          obj.id = this.detailInfo.id;
          obj.apiUrl = this.apiConfig.giftUpdate;
          data = await this.$store.dispatch("apiEvent", obj);
        } else {
          obj.apiUrl = this.apiConfig.giftCreate;
          data = await this.$store.dispatch("apiEvent", obj);
        }
        if (data == "000104") {
          this.timeoutEvent();
          return;
        }
        if (!data) return;
        if (data.data.status_code === "0") {
          this.$store.state.edit = false;
          this.$router.go(-1);
        }
      } catch (err) { }
    },
    Delete() {
      this.showWarning(1);
    },
    async callDelete() {
    },
    handleCheckUploadFileSize(file) {
      const sizeKB = file.size / 1024
      if (sizeKB > 5120) {
        this.uploadErr = true
        return false
      } else {
        this.uploadErr = false
        return true
      }
    }
  }
};
</script>
